import { useMutation, useQuery } from '@apollo/client';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import AppraiserForm from '../../AppraiserForm/components/AppraiserForm';
import AppraiserDataMapper from '../../AppraiserForm/mappers/AppraiserDataMapper';
import ApolloError from '../../shared/components/ApolloError';
import EDIT_CURRENT_APPRAISER from '../queries/editCurrentAppraiser';
import GET_CURRENT_USER_APPRAISER_INFO from '../queries/getCurrentUserAppraiserInfo';

const AppraiserProfile = () => {
  const [appraiserFormData, setAppraiserFormData] = useState({});
  const [editSuccessMessage, setEditSuccessMessage] = useState('');

  const {
    data: appraiserInfoData,
    loading: appraiserInfoLoading,
    error: appraiserInfoError
  } = useQuery(GET_CURRENT_USER_APPRAISER_INFO, {
    onCompleted: appraiserInfoData => {
      if (!appraiserInfoData.currentAppraiserInfo) {
        return;
      }

      setAppraiserFormData(
        AppraiserDataMapper.appraiserDataToEditFields(appraiserInfoData.currentAppraiserInfo)
      );
    }
  });

  const appraiserNonEditableData = appraiserInfoData?.currentAppraiserInfo
    ? AppraiserDataMapper.appraiserDataToViewFields(appraiserInfoData.currentAppraiserInfo)
    : {};

  const isFormEdited =
    appraiserInfoData &&
    appraiserInfoData.currentAppraiserInfo &&
    !_.isEqual(
      appraiserFormData,
      AppraiserDataMapper.appraiserDataToEditFields(appraiserInfoData.currentAppraiserInfo)
    );

  useEffect(() => {
    if (isFormEdited && editSuccessMessage) {
      setEditSuccessMessage('');
    }
  }, [isFormEdited, editSuccessMessage]);

  const [editCurrentAppraiser, { error: editAppraiserError }] = useMutation(EDIT_CURRENT_APPRAISER);

  const saveAppraiser = async editedDomainExperiences => {
    const appraiserFormInput = AppraiserDataMapper.currentAppraiserDataToApolloInput(
      appraiserFormData,
      editedDomainExperiences
    );

    await editCurrentAppraiser({
      variables: {
        appraiser: appraiserFormInput
      }
    });
    setEditSuccessMessage('Edits Submitted Successfully.');
  };

  if (appraiserInfoError || editAppraiserError) {
    return <ApolloError />;
  }

  return (
    <div className='appraiser-profile-page'>
      <AppraiserForm
        appraiserFormData={appraiserFormData}
        appraiserNonEditableData={appraiserNonEditableData}
        setAppraiserFormData={setAppraiserFormData}
        appraiserInfoLoading={appraiserInfoLoading}
        isAppraiser={true}
        canEditAdditionalInformation={true}
        isFormEdited={isFormEdited}
        saveAppraiser={saveAppraiser}
        editSuccessMessage={editSuccessMessage}
      />
    </div>
  );
};

export default AppraiserProfile;
